<template>
  <div :class="`bg-${remainingDaysColor}`">
    <div class="container py-2 text-white">
      <div class="row align-items-center justify-content-center">
        <div class="col-12 col-md-6 mb-3 mb-lg-0 text-center text-lg-start">
          {{ $tc("remaining", remainingDays) }}
        </div>

        <div class="col-12 col-md-6 text-center text-lg-end">
          <router-link
            :class="`btn-${remainingDaysColor}`"
            :to="{ name: 'membership.extend' }"
            class="btn btn-sm border border-white text-white"
          >
            {{ $t("extendMembership") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheRemainingDaysStripe",
  computed: {
    remainingDays() {
      return this.$store.getters["membership/getRemainingDays"];
    },
    remainingDaysColor() {
      return this.remainingDays > 10 ? "success" : "danger";
    },
  },
};
</script>

<style scoped></style>
